export default {
  title: "How would you like to participate in ANTIPARTIDO?",
  subtitle: "Select your participation role. You can change it later from your profile.",
  options: {
    representative: "Representative in an electoral district or State",
    notario: "CITIZEN ELECTORAL NOTARY at the polling station on election day",
    none: "None of the above",
  },
  infoModal: {
    title: "Participation roles",
    representative: {
      title: "Representative",
      description:
        "As a Representative, you will act as a liaison between ANTIPARTIDO and the citizens of your district or State. Your role is to promote civic participation and represent your community's interests in electoral processes.",
    },
    notario: {
      title: "Citizen Electoral Notary",
      description:
        "As a Citizen Electoral Notary, you will participate on election day at polling stations to verify and witness the process. Your presence guarantees the transparency and legitimacy of the electoral day.",
    },
    close: "Got it",
  },
  save: "Save",
  saving: "Saving...",
  error: "Error saving your selection. Please try again.",
  validation: "You must select at least one option.",
  reviewer: {
    subtitle: "Review account: participation roles are fixed and cannot be changed.",
  },
}
